import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="min-w-0">
        <div className="flex items-center gap-2.5">
          <span className="w-1 h-5 rounded-full bg-accent-500"></span>
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">{title}</h2>
        </div>
        {subtitle && (
          <p className="text-xs md:text-sm text-foreground-500 mt-1.5 pl-3.5">{subtitle}</p>
        )}
      </div>
      {moreTo && moreLabel && (
        <Link
          to={moreTo}
          className="shrink-0 text-xs md:text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap flex items-center gap-1"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}